import { giftState } from '@theme/pe-gift-rules';

// One module-level listener; native Liquid checks remain available without JavaScript.
document.addEventListener('submit', async event => {
  if (!(event.target instanceof HTMLFormElement) || event.target.id !== 'cart-form') return;
  if (!(event.submitter instanceof HTMLElement) || event.submitter.getAttribute('name') !== 'checkout') return;
  const panel = document.querySelector('[data-pe-gift-cart]');
  if (!panel || event.defaultPrevented) return;
  event.preventDefault();
  const button = event.submitter;
  const error = panel.querySelector('[role="alert"]');
  button.setAttribute('disabled', '');
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(panel.dataset.error);
    const cart = await response.json();
    if (!giftState(cart).valid) throw new Error(panel.dataset.invalid);
    window.location.assign(`${root}checkout`);
  } catch (failure) {
    if (error) { error.textContent = failure.message || panel.dataset.error; error.hidden = false; }
    button.removeAttribute('disabled');
  }
}, true);
